import React, { useEffect, useState } from 'react';
import { listarSupervisores } from '../../services/supervisorService';

const SupervisorList = () => {
    const [supervisores, setSupervisores] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await listarSupervisores();
                console.log('Dados dos supervisores:', response.data); // Verifique a estrutura dos dados
                setSupervisores(response.data);
            } catch (error) {
                console.error('Erro ao buscar supervisores:', error);
            }
        };
        fetchData();
    }, []);

    return (
        <div>
            <h2>Lista de Supervisores</h2>
            <ul>
                {supervisores.map((supervisor) => (
                    <li key={supervisor.id}>
                        {/* Acesse o nome do supervisor através de supervisor.Usuario.nome */}
                        {supervisor.Usuario ? supervisor.Usuario.nome : 'Nome não disponível'} - {supervisor.area_especializacao}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SupervisorList;